import { StringValueTextModel, DataApi } from "@/openapi";
import { defineStore } from "pinia";
export interface DataState {
  originCountries: StringValueTextModel[];
  currencies: string[];
}

const dataApi = new DataApi(undefined, "");
const getInitialState = (): DataState => ({
  originCountries: [],
  currencies: [],
});

export const useDataStore = defineStore("data", {
  state: getInitialState,
  getters: {},
  actions: {
    async fetchCountriesOfOrigin() {
      if (this.originCountries?.length) {
        return;
      }

      try {
        const response = await dataApi.getCountriesOfOrigin();
        this.originCountries = response.data;
      } catch {
        //THERE IS NO ERROR HANDLING AT THE MOMENT
      }
    },
    async fetchCurrencies() {
      if (this.currencies?.length) {
        return;
      }

      try {
        const response = await dataApi.getCurrencies();
        this.currencies = response.data;
      } catch {
        //THERE IS NO ERROR HANDLING AT THE MOMENT
      }
    },
  },
});
